import axios from "axios"
import { env } from '../constants'


/* Messages */
export const messages = token => {
    const uri = `${env.startpoint}support/messages`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then(response => response).catch(error => error.response)
}